import { IAccountDetailsResponse, IApiResponse } from "@miplatform/types";

export interface CustomerPricingDetailsContextType {
  accountDetails: IAccountDetailsResponse | null;
  isViewModelLoading: boolean;
  tabFormState: TabFormState;
  setTabFormState: (state: TabFormState) => void;
  setSaveHandler: (handler: (() => Promise<IApiResponse>) | null) => void;
  getAccountDetails: (accountId: string) => void;
  handleSave: () => Promise<void>;
}

export interface IAssignPriceLevelPayload {
  accountId: string;
  priceLevelId: string;
}

export interface TabFormState {
  isDirty: boolean;
  isValid: boolean;
  isLoading: boolean;
}

export enum CustomerPricingDetailsTabs {
  PriceLevel = "PriceLevel",
  FloorsDrops = "FloorsDrops",
  DrawsSetup = "DrawsSetup",
  DrawsDistribution = "DrawsDistribution",
  BidLineItems = "BidLineItems",
  OptionLineItems = "OptionLineItems",
  Items = "Items",
  CategoryMarkup = "CategoryMarkup",
  PriceMatrix = "PriceMatrix",
  History = "History",
}
